import { SurveyType } from '@purespectrum1/ui/marketplace/shared/interfaces/survey.interface';
import { SurveyListing } from 'src/app/shared/services/buyer-api/survey.interface';

export type WidgetSurveyType = SurveyType | 'tc';
export type WidgetInfo = {
  image: string;
  type: WidgetSurveyType;
};

export class SurveyWidgetHelper {
  constructor(private readonly _survey: SurveyListing) {}

  public type(): WidgetSurveyType {
    if (
      this._survey?.tracker?.enable &&
      this._survey?.trackerCount &&
      this._survey?.mc_unique_id
    ) {
      return 'tracker';
    }

    if (!!this._survey?.mc_count && !this._survey?.mc?.SVP) {
      return 'mc';
    }

    if (!!this._survey?.tc_count) {
      return 'tc';
    }

    return 'standard';
  }

  public image(): string {
    switch (this.type()) {
      case 'tracker':
        return 'assets/img/widgets/tracker.png';
      case 'mc':
        return 'assets/img/widgets/multiCountry.svg';
      case 'tc':
        return 'assets/img/widgets/trafficChannels.svg';
      default:
        return '';
    }
  }

  public info(): WidgetInfo {
    return {
      image: this.image(),
      type: this.type(),
    };
  }
}
